export const transformType = (type: string): 'text' | 'number' => {
  const typeMap: { [key: string]: 'text' | 'number' } = {
    string: 'text',
    number: 'number',
  };
  const normalizedType = type.trim().toLowerCase();
  return typeMap[normalizedType] || 'text';
};
